import React from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import projectData from '../data/projectData';
import '../styles/ProjectDetail.css';

const ProjectDetail = () => {
  const { id } = useParams();
  const project = projectData.find((p) => p.id.toString() === id);

  if (!project) return <main className="project-detail"><SEO title="Project Not Found | Bularis Tech" description="The requested portfolio project could not be found." path={`/portfolio/${id}`} noIndex /><h1>Project not found</h1></main>;

  return (
    <main className={`project-detail${project.capabilities ? ' project-detail-featured' : ''}`}>
      <SEO title={`${project.title} | Bularis Tech`} description={project.shortDesc} path={`/portfolio/${id}`} noIndex={!project.indexable} />
      <div className="container">
        {project.eyebrow && <span className="project-eyebrow">{project.eyebrow}</span>}
        <h1>{project.title}</h1>
        <p>{project.fullDesc}</p>
        {project.objective && <section className="project-section"><h2>Project objective</h2><p>{project.objective}</p></section>}
        {project.capabilities && <section className="project-section"><h2>Implemented capabilities</h2><div className="project-capabilities">{project.capabilities.map((capability) => <article key={capability.title}><h3>{capability.title}</h3><p>{capability.description}</p></article>)}</div></section>}
        {project.engineering && <section className="project-section"><h2>Engineering and integration work</h2><ul>{project.engineering.map((item) => <li key={item}>{item}</li>)}</ul></section>}
        {project.status && <section className="project-section project-status"><h2>Current status</h2><p>{project.status}</p></section>}
        {project.limitations && <section className="project-section"><h2>Scope and current limits</h2><p>These capabilities are not presented as completed product features. They require additional implementation and validation for each business.</p><ul>{project.limitations.map((item) => <li key={item}>{item}</li>)}</ul></section>}
        {project.capabilities && <div className="project-cta"><div><h2>Discuss a business voice workflow</h2><p>Tell us about your calls, systems, and goals. We can assess a tailored approach and its technical requirements.</p></div><Link to="/contact">Discuss your project</Link></div>}
        <Link to="/portfolio" className="back-link">← Back to Portfolio</Link>
      </div>
    </main>
  );
};

export default ProjectDetail;
